import I18n from '../../../config/i18n';
import GoogleTagManagerNg from '../../../features/tracking/GoogleTagManagerNg';

import './ContactHotline.css';

function trackClickEvent(): void {
  GoogleTagManagerNg.event('contact_telephone', {});
}

export default function ContactHotline(): JSX.Element {
  return (
    <div className="contact-hotline">
      <div className="contact-hotline__wrapper">
        {I18n.t('header.phone_annotation_renter')}{' '}
        <a href={`tel:${I18n.t('header.phone_renter')}`} onClick={trackClickEvent}>
          {I18n.t('header.phone_renter')}
        </a>
      </div>
    </div>
  );
}
